import { connect } from 'react-redux';
import GaragesList from 'components/garages/GaragesList';
import {
  fetchGaragesData,
  setGridFilter,
  clearGridFilter,
} from 'data/garages/Garages.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      filters: state.garages.filters,
      fetchingGarages: state.garages.fetchingGarages,
      garagesData: state.garages.garagesData,
      user: state.app.user,
    },
    state,
    'regions',
    'taxOffices',
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFilter: (name, value) => dispatch(setGridFilter(name, value)),
    clearFilters: () => dispatch(clearGridFilter()),
    fetchGarages: () => dispatch(fetchGaragesData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GaragesList);
